<script>
import { authComputed, authMethods } from '@state/helpers'
import Layout from '@layouts/main'
import appConfig from '@src/app.config'
import ProfileUpdate from '@components/profileDataUpdate'
import {
  ADMIN_ROLE,
  TEACHER_ROLE,
  COLLEGE_ROLE,
  ADMINISTRATOR_ROLE,
} from '@utils/constant'
export default {
  page: {
    title: 'Profile',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, ProfileUpdate: ProfileUpdate },
  data() {
    return {
      profileUpdate: 0,
      profileUpdateData: [],
      AWSUrl: `${process.env.VUE_APP_AWS_URL}`,
      ADMIN_ROLE: ADMIN_ROLE,
      TEACHER_ROLE: TEACHER_ROLE,
      COLLEGE_ROLE: COLLEGE_ROLE,
      ADMINISTRATOR_ROLE: ADMINISTRATOR_ROLE,
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...authMethods,
    getProfileEdit(data) {
      this.profileUpdate = 1
      this.profileUpdateData = data
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <div class="text-center card-box">
          <div>
            <img
              v-if="profileData.profilePic"
              :src="AWSUrl + profileData.profilePic"
              class="rounded-circle avatar-xl img-thumbnail mb-2"
              alt="profile-image"
            />

            <img
              v-else
              src="@assets/images/profile.png"
              class="rounded-circle avatar-xl img-thumbnail mb-2"
              alt="profile-image"
            />

            <p class="text-uppercase mb-3"
              ><i>{{ profileData ? profileData.role : '' }}</i></p
            >

            <div class="text-left">
              <p class="font-13"
                ><strong>Full Name :</strong>
                <span class="ml-2">{{
                  profileData
                    ? profileData.first_name +
                      ' ' +
                      profileData.last_name +
                      ' (' +
                      profileData.role +
                      ')'
                    : ''
                }}</span></p
              >

              <p class="font-13"
                ><strong>Email :</strong
                ><span class="ml-2">{{
                  profileData ? profileData.email : ''
                }}</span></p
              >

              <p
                v-if="
                  profileData.role !== ADMIN_ROLE ||
                  profileData.role !== ADMINISTRATOR_ROLE
                "
                class="font-13"
                ><strong>College Name :</strong
                ><span class="ml-2">{{
                  profileData ? profileData.college_name : ''
                }}</span></p
              >

              <p class="font-13"
                ><strong>Mobile :</strong>
                <span class="ml-2">{{
                  profileData ? profileData.phone : ''
                }}</span></p
              >

              <p class="font-13"
                ><strong>Location :</strong>
                <span class="ml-2">{{
                  profileData && profileData.country !== undefined
                    ? profileData.city + ', ' + profileData.country
                    : 'NA'
                }}</span></p
              >
            </div>
          </div>
          <b-button
            v-b-modal="'profile-update-modal'"
            type="submit"
            variant="primary"
            class="btn-block"
            @click="getProfileEdit(profileData)"
            >Edit Profile</b-button
          >
        </div>
        <ProfileUpdate
          v-if="profileUpdate"
          :data="profileUpdateData"
        ></ProfileUpdate>
      </div>
    </div>
  </Layout>
</template>

<style>
.editCard {
  padding: 5px;
  margin-top: 50px;
  margin-left: 250px;
}
.editBtn {
  min-width: 111px;
  height: 39px;
  color: #fff;
  text-align: center;
  background: #0468ff;
}
.contactCard {
  margin-top: 30px;
  margin-left: 250px;
}
.contactCardRight {
  display: flex;
}
.icons {
  float: left;
  width: 30px;
  height: 20px;
  font-size: 22px;
  color: #000;
  border-radius: 100%;
}
.contactLeft {
  float: left;
  padding-left: 12px;
  margin: 0;
}
.contactRight {
  display: flex;
  float: left;
  padding-left: 40px;
  margin: 0;
}

.basicCard {
  width: 90%;
  padding: 10px;
  margin-top: 50px;
  margin-left: 30px;
}

.basicCardLeft {
  display: flex;
  float: left;
}

.basicCardRight {
  display: flex;
  float: right;
}
</style>
